module.exports = __webpack_public_path__ + "img/Paymen-Completed-en.8d2b7a5.png";